import { Col, Row } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import FormField, { FormFieldCommonProps } from "./FormField";
import { Text } from "@merge-api/merge-javascript-shared";

interface Props extends FormFieldCommonProps {
  choices: Array<{
    id: string;
    label: string;
    value: { stepType: string; stepImg: string; helptext: string };
  }>;
  currentValue: any;
  placeholder: string;
  onChange: (e: any) => void;
  title: string;
}

const SearchableDropdown = ({ choices, onChange, placeholder, title }: Props) => (
  <FormField title={title}>
    <Typeahead
      id="Searchable Dropdown"
      options={choices}
      onChange={onChange}
      placeholder={placeholder}
      renderMenuItemChildren={(option: any) => (
        <Row key={option.id} style={{ display: "flex", flexDirection: "row" }}>
          <Col xs={3}>
            <div style={{ marginRight: "10px" }}>
              {option.value.stepImg ? (
                <img src={option.value.stepImg} className="card-image items-center" alt="" />
              ) : (
                <div className="w-[45px] h-[45px] rounded-[5px] border border-gray-10 flex items-center justify-center bg-green-60 text-white">
                  <Text variant="h4">{option.label.charAt(0)}</Text>
                </div>
              )}
            </div>
          </Col>
          <Col style={{ justifyContent: "left" }} xs={9}>
            <Row>
              <span>{option.label}</span>
            </Row>
            <Row>
              <span className="small text-muted">{option.value.helptext}</span>
            </Row>
          </Col>
        </Row>
      )}
    />
  </FormField>
);

export default SearchableDropdown;
